"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createExternalHelper = void 0;
var imgix_js_core_wrapper_1 = require("./imgix-js-core-wrapper");
var createExternalHelper = function (fieldConfigFactory) {
    return function (_a) {
        var imgixClientOptions = _a.imgixClientOptions, args = __rest(_a, ["imgixClientOptions"]);
        return (__assign({}, fieldConfigFactory(__assign(__assign({}, args), { imgixClient: (0, imgix_js_core_wrapper_1.createImgixURLBuilder)(imgixClientOptions) }))));
    };
};
exports.createExternalHelper = createExternalHelper;
//# sourceMappingURL=createExternalHelper.js.map